import { JSX } from "react";


interface PerformanceOverviewAccordionProps {
  effectivenessScore: number;
  efficiencyScore: number;
}

const PerformanceOverviewAccordion = (props: PerformanceOverviewAccordionProps): JSX.Element => {

  return (
    <>
      <div className="d-flex flex-row mb-2 p-2 border rounded">
        <div className="col">Average Quality (Effectiveness) Score</div>
        <div className="col">{props.effectivenessScore <= 0 ? '---' : props.effectivenessScore}</div>
      </div>
      <div className="d-flex flex-row p-2 border rounded">
        <div className="col">Average Cost (Efficiency) Score</div>
        <div className="col">{props.efficiencyScore <= 0 ? '---' : props.efficiencyScore}</div>
      </div>
    </>
  )
}

export default PerformanceOverviewAccordion;
